import type {
  Locale,
  LocaleMessages,
  LocaleNamespace,
  LocaleNamespaceLoader,
} from "./i18n-types.ts";
import { allLocales } from "./i18n-types.ts";

export { allLocales };
export type { Locale, LocaleMessages, LocaleNamespace, LocaleNamespaceLoader };

const PREFERRED_LANGUAGE_KEY = "preferred-language";

export function getStoredPreferredLanguage(): Locale | undefined {
  try {
    const storedLocale = localStorage.getItem(PREFERRED_LANGUAGE_KEY);
    if (storedLocale && allLocales.includes(storedLocale as Locale)) {
      return storedLocale as Locale;
    }
    return undefined;
  } catch {
    return undefined;
  }
}

export function setStoredPreferredLanguage(locale: Locale): void {
  try {
    localStorage.setItem(PREFERRED_LANGUAGE_KEY, locale);
  } catch {
    // storage unavailable (e.g. privacy settings, opaque origins)
  }
}

export function getLocaleBasedOfPreferredLanguages(
  preferredLanguage: string | undefined,
  otherLanguages: readonly string[],
): Locale {
  const storedLocale = getStoredPreferredLanguage();
  if (storedLocale) {
    return storedLocale;
  }

  if (preferredLanguage) {
    const preferredLocale = getLocaleFromLanguage(
      preferredLanguage.toLowerCase(),
    );

    if (preferredLocale) {
      return preferredLocale;
    }
  }

  for (const otherLanguage of otherLanguages) {
    const otherLocale = getLocaleFromLanguage(otherLanguage.toLowerCase());

    if (otherLocale) {
      return otherLocale;
    }
  }

  return "en";
}

function getLocaleFromLanguage(language: string): Locale | undefined {
  const localeFromLanguage = language.substring(0, 2);

  for (const locale of allLocales) {
    if (locale === localeFromLanguage) {
      return locale;
    }
  }
}
